import { AddressSchema } from "@redotech/account-common/address";
import { dropoffProviderType } from "@redotech/redo-return-core-common/dropoff-provider";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { PurchaseLabelType } from "./purchase-label";

export enum PurchaseDropoffError {
  NOT_ELIGIBLE = "not_eligible",
  PROVIDER_ERROR = "provider_error",
  INTERNAL_ERROR = "internal_error",
}

export const purchaseDropoff = {
  name: "purchaseDropoff" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    dropoffId: z.string().optional(),
    provider: z.enum(dropoffProviderType),
    /**
     * Merchant ship-to (return destination) address driving eligibility and the
     * provider's location/RMA resolution. Passed in (not read from the return)
     * so the dropoff reflects the address the merchant is actually using; must
     * carry the merchant config fields (blueYonderLocationId, returnsCenterId,
     * externalReturnHub) for the corresponding providers to be eligible.
     */
    merchantAddress: AddressSchema,
    /**
     * `new` adds a dropoff; `replace` first voids (without refunding) the
     * existing label for `shipmentId` before generating the dropoff, charging
     * only the difference — the same as label→label replace.
     */
    labelType: createEnum(PurchaseLabelType),
    shipmentId: z.string().optional(),
    /** Merchant cost already paid for the replaced label, credited against the
     * drop-off charge so label→drop-off only bills the difference. */
    originalLabelCost: z.number().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    qrCodeUrl: z.string().optional(),
    trackingNumber: z.string().optional(),
    error: createEnum(PurchaseDropoffError).optional(),
    charge: z.number().optional(),
  }),
};
